import { render, staticRenderFns } from "./InvoicesInboundTableMobile.vue?vue&type=template&id=975ff836&scoped=true"
import script from "./InvoicesInboundTableMobile.vue?vue&type=script&lang=js"
export * from "./InvoicesInboundTableMobile.vue?vue&type=script&lang=js"
import style0 from "./InvoicesInboundTableMobile.vue?vue&type=style&index=0&id=975ff836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975ff836",
  null
  
)

export default component.exports